import { render, staticRenderFns } from "./QRadioCustom.vue?vue&type=template&id=00f7681c&"
import script from "./RadioCustom.js?vue&type=script&lang=js&"
export * from "./RadioCustom.js?vue&type=script&lang=js&"
import style0 from "./QRadioCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
